(() => {
  'use strict';

  const LABELS = {
    it: { previous: 'Slide precedente', next: 'Slide successiva', goTo: 'Vai alla slide' },
    en: { previous: 'Previous slide', next: 'Next slide', goTo: 'Go to slide' },
    es: { previous: 'Diapositiva anterior', next: 'Diapositiva siguiente', goTo: 'Ir a la diapositiva' }
  };

  function languageLabels() {
    const language = (document.documentElement.lang || 'it').toLowerCase().slice(0, 2);
    return LABELS[language] || LABELS.it;
  }

  function initializeHero(hero) {
    if (!hero || hero.dataset.pwsStableCarousel === 'true') return;

    const track = hero.querySelector('.carousel-track');
    const wrapper = hero.closest('.proworksite-wrapper') || hero.parentElement;
    const slides = track ? Array.from(track.querySelectorAll('.carousel-slide')) : [];
    const dots = Array.from(hero.querySelectorAll('.carousel-navigation .nav-dot'));
    const buttons = wrapper
      ? Array.from(wrapper.querySelectorAll('.hero-benefits > div.absolute button'))
      : [];

    if (!track || slides.length === 0) return;

    // The original custom-HTML section already installs touch navigation and
    // marks the track. Keep that listener when present so a swipe advances
    // exactly one slide; the stable controller below still owns buttons,
    // dots, accessibility state and the public navigation functions.
    const hasSectionTouchController = track.dataset.proworksiteInitialized === 'true';

    hero.dataset.pwsStableCarousel = 'true';
    let currentIndex = Math.max(0, dots.findIndex((dot) => dot.classList.contains('active-dot')));
    let touchStartX = null;
    let touchStartY = null;
    const labels = languageLabels();

    function render(index) {
      currentIndex = (index + slides.length) % slides.length;

      const activeImage = slides[currentIndex].querySelector('img[loading="lazy"]');
      if (activeImage) {
        activeImage.loading = 'eager';
        activeImage.fetchPriority = 'high';
      }

      track.style.transform = `translate3d(-${currentIndex * 100}%, 0, 0)`;

      slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === currentIndex ? 'false' : 'true');
      });

      dots.forEach((dot, dotIndex) => {
        const isCurrent = dotIndex === currentIndex;
        dot.classList.toggle('active-dot', isCurrent);
        dot.setAttribute('aria-current', isCurrent ? 'true' : 'false');
      });
    }

    dots.forEach((dot, dotIndex) => {
      dot.removeAttribute('onclick');
      dot.setAttribute('role', 'button');
      dot.setAttribute('tabindex', '0');
      dot.setAttribute('aria-label', `${labels.goTo} ${dotIndex + 1}`);
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        render(dotIndex);
      });
      dot.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        render(dotIndex);
      });
    });

    const previousButton = buttons[0];
    const nextButton = buttons[1];

    if (previousButton) {
      previousButton.removeAttribute('onclick');
      previousButton.type = 'button';
      previousButton.setAttribute('aria-label', labels.previous);
      previousButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        render(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.removeAttribute('onclick');
      nextButton.type = 'button';
      nextButton.setAttribute('aria-label', labels.next);
      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        render(currentIndex + 1);
      });
    }

    if (!hasSectionTouchController) {
      hero.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }, { passive: true });

      hero.addEventListener('touchend', (event) => {
        if (touchStartX === null || touchStartY === null || event.changedTouches.length !== 1) {
          touchStartX = null;
          touchStartY = null;
          return;
        }

        const distanceX = event.changedTouches[0].clientX - touchStartX;
        const distanceY = event.changedTouches[0].clientY - touchStartY;
        if (Math.abs(distanceX) >= 45 && Math.abs(distanceX) > Math.abs(distanceY) * 1.2) {
          render(currentIndex + (distanceX < 0 ? 1 : -1));
        }
        touchStartX = null;
        touchStartY = null;
      }, { passive: true });
    }

    window.nextSlide = () => render(currentIndex + 1);
    window.prevSlide = () => render(currentIndex - 1);
    window.manualGoto = (index) => render(Number(index) || 0);
    render(currentIndex);
  }

  function initializeAll(root = document) {
    if (root.matches && root.matches('.hero-carousel')) initializeHero(root);
    if (root.querySelectorAll) root.querySelectorAll('.proworksite-hero .hero-carousel').forEach(initializeHero);
  }

  function start() {
    initializeAll(document);
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
